import { render, staticRenderFns } from "./HostingComponent.vue?vue&type=template&id=695712e8&scoped=true&"
import script from "./HostingComponent.vue?vue&type=script&lang=js&"
export * from "./HostingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695712e8",
  null
  
)

export default component.exports